<ion-app class="flex flex-col w-full h-full relative">
  <!-- Navbar -->
  <app-navbar class="flex w-full relative z-[60]" *ngIf="showNavbar"/>
  
  <div class="flex flex-row h-full w-full overflow-hidden relative">
    <!-- Sidebar - Desktop (static/fixed) & Mobile (drawer) -->
    <app-sidebar class="z-50 h-full shrink-0 md:w-64 block" />

    <!-- Main Content Area -->
    <div class="flex flex-col flex-1 w-full h-full relative overflow-auto md:overflow-hidden transition-all duration-300">
        <app-freight-history class="absolute z-40"/>
        
        <ion-content #content class="no-scrollbar has-floating-footer" [style.--background]="'#F8F9FA'">
          <div id="main-content" class="w-full mx-auto">
            <div class="flex flex-col w-full no-scrollbar px-2 md:px-0 pb-8 md:pb-0">
              <router-outlet />
            </div>
          </div>
        </ion-content>
    </div>
  </div>

  <app-footer class="md:hidden z-50"></app-footer>
</ion-app>
